import { render, staticRenderFns } from "./InformacoesDeTransporteGrid.vue?vue&type=template&id=42a5e99d&"
import script from "./InformacoesDeTransporteGrid.vue?vue&type=script&lang=ts&"
export * from "./InformacoesDeTransporteGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports